var consumer = {
  "units": {
    "Wh": {
      "single": "watt-hora",
      "plural": "watt-horas",
      "annotated_abv": "(Wh)",
      "abv": "Wh",
      "definition": "A geração e utilização de energia são medidas em watt-horas (Wh). Um kilowatt-hour (kWh) é igual a 1.000 watt-horas e é a unidade comumente usada pelas concessionárias de energia elétrica nas contas mensais."
    },
    "kWh": {
      "single": "kilowatt-hora",
      "plural": "kilowatt-horas",
      "annotated_abv": "(kWh)",
      "abv": "kWh"
    },
    "MWh": {
      "single": "megawatt-hora",
      "plural": "megawatt-horas",
      "annotated_abv": "(MWh)",
      "abv": "MWh"
    },
    "GWh": {
      "single": "gigawatt-hora",
      "plural": "gigawatt-horas",
      "annotated_abv": "(GWh)",
      "abv": "GWh"
    },
    "TWh": {
      "single": "terawatt-hora",
      "plural": "terawatt-horas",
      "annotated_abv": "(TWh)",
      "abv": "TWh"
    },
    "PWh": {
      "single": "petawatt-hora",
      "plural": "petawatt-horas",
      "annotated_abv": "(PWh)",
      "abv": "PWh"
    },
    "EWh": {
      "single": "exawatt-hora",
      "plural": "exawatt-horas",
      "annotated_abv": "(EWh)",
      "abv": "EWh"
    },
    "ZWh": {
      "single": "zettawatt-hora",
      "plural": "zettawatt-horas",
      "annotated_abv": "(ZWh)",
      "abv": "ZWh"
    },
    "YWh": {
      "single": "yottawatt-hora",
      "plural": "yottawatt-horas",
      "annotated_abv": "(YWh)",
      "abv": "YWh"
    },
    "W": {
      "single": "watt",
      "plural": "watts",
      "annotated_abv": "(C)",
      "abv": "W"
    },
    "kW": {
      "single": "kilowatt",
      "plural": "kilowatts",
      "annotated_abv": "(kW)",
      "abv": "kW"
    },
    "MW": {
      "single": "megawatt",
      "plural": "megawatts",
      "annotated_abv": "(MW)",
      "abv": "MW"
    },
    "GW": {
      "single": "gigawatt",
      "plural": "gigawatts",
      "annotated_abv": "(GW)",
      "abv": "GW"
    },
    "TW": {
      "single": "terawatt",
      "plural": "terawatts",
      "annotated_abv": "(TW)",
      "abv": "TW"
    },
    "PW": {
      "single": "petawatt",
      "plural": "petawatts",
      "annotated_abv": "(PW)",
      "abv": "PW"
    },
    "EW": {
      "single": "exawatt",
      "plural": "exawatts",
      "annotated_abv": "(EW)",
      "abv": "EW"
    },
    "ZW": {
      "single": "zettawatt",
      "plural": "zettawatts",
      "annotated_abv": "(ZW)",
      "abv": "ZW"
    },
    "YW": {
      "single": "yottawatt",
      "plural": "yottawatts",
      "annotated_abv": "(YW)",
      "abv": "YW"
    },
    "percent": {
      "single": "percentual",
      "plural": "percentual",
      "annotated_abv": "%",
      "abv": "%"
    },
    "minutes": {
      "zero": "minutos",
      "ltone": "minuto",
      "single": "minuto",
      "plural": "minutos"
    },
    "hours": {
      "zero": "horas",
      "ltone": "hora",
      "single": "hora",
      "plural": "horas"
    },
    "months": {
      "zero": "meses",
      "ltone": "mês",
      "single": "mês",
      "plural": "meses"
    },
    "years": {
      "zero": "anos",
      "ltone": "ano",
      "single": "ano",
      "plural": "anos"
    },
    "days": {
      "zero": "dias",
      "ltone": "dia",
      "single": "dia",
      "plural": "dias"
    },
    "nights": {
      "zero": "noites",
      "ltone": "noite",
      "single": "noite",
      "plural": "noites"
    },
    "batteries": {
      "zero": "baterias",
      "ltone": "Bateria",
      "single": "Bateria",
      "plural": "baterias"
    },
    "trees": {
      "zero": "Árvores",
      "ltone": "Árvore",
      "single": "Árvore",
      "plural": "Árvores"
    },
    "kg": {
      "zero": "kg",
      "ltone": "kg",
      "single": "kg",
      "plural": "kgs"
    },
    "laps": {
      "zero": "voltas",
      "ltone": "volta",
      "single": "volta",
      "plural": "voltas"
    },
    "barrels": {
      "zero": "barris",
      "ltone": "barril",
      "single": "barril",
      "plural": "barris"
    },
    "flights": {
      "zero": "voos",
      "ltone": "voo",
      "single": "voo",
      "plural": "voos"
    },
    "launches": {
      "zero": "lançamentos",
      "ltone": "lançamento",
      "single": "lançamento",
      "plural": "lançamentos"
    }
  },
  "timeAgo": {
    "now": "Now",
    "second": {
      "single": "1 segundo atrás",
      "plural": "%{number} segundos atrás"
    },
    "minute": {
      "single": "1 minutos atrás",
      "plural": "%{number} minutos atrás"
    },
    "hour": {
      "single": "1 horas atrás",
      "plural": "%{number} horas atrás"
    },
    "day": {
      "single": "1 dia atrás",
      "plural": "%{number} dias atrás"
    },
    "week": {
      "single": "1 semanas atrás",
      "plural": "%{number} semanas atrás"
    },
    "month": {
      "single": "1 mês atrás",
      "plural": "%{number} meses atrás"
    },
    "year": {
      "single": "1 ano atrás",
      "plural": "%{number} anos atrás"
    }
  },
  "weather": {
    "unknown": "Condições meteorológicas desconhecidas",
    "footer": "Dados meteorológicos fornecidos por Instituto do Tempo",
    "credit": "Fornecidos por Instituto do Tempo"
  },
  "reports": {
    "title": "Raporty",
    "submit": "Gerar relatório",
    "to": "até",
    "selectDate": "Select the date",
    "insufficientData": "VPor favor, verifique novamente amanhã. A nuvem Enphase não coletou os dados necessários para criar relatórios.",
    "1": {
      "name": "Produção diária",
      "title": "Produção de energia da unidade",
      "description": "Resumo da produção diária de energia deste local. Uma vez que o relatório oferece dados de energia por dia, você pode solicitar dias até o dia de ontem."
    },
    "2": {
      "name": "Produção recente",
      "title": "Produção de energia recente na unidade",
      "description": "O resumo da última semana da produção de energia em incrementos de 5 minutos deste local."
    },
    "6": {
      "name": "Produção mensal",
      "title": "Produção mensal de energia",
      "description": "O resumo de um mês de produção de energia e pico de energia deste local."
    },
    "15": {
      "name": "Consumo diário",
      "title": "Consumo de energia local",
      "description": "O resumo do consumo diário de energia deste local. Uma vez que o relatório oferece dados de energia por dia, você pode solicitar dias até o dia de ontem."
    },
    "16": {
      "name": "Consumo recente",
      "title": "Consumo de energia recente no local",
      "description": "O resumo do consumo de energia da última semana em incrementos de 15 minutos deste local."
    },
    "17": {
      "name": "Energia Líquida Mensal",
      "title": "Energia Líquida Mensal",
      "description": "Este relatório resume a energia produzida, consumida, importada e exportada desta unidade a cada 15 minutos do mês selecionado. Se o sistema incluir baterias CA, o relatório também mostra a energia armazenada e descarregada."
    },
    "19": {
      "name": "Relatório de bateria",
      "title": "Relatório de bateria",
      "description": "Este relatório oferece os últimos 7 dias de dados da bateria."
    },
    "3": {
      "name": "Produção de Energia diária por Módulo",
      "title": "Produção de Energia diária por Módulo",
      "description": "Este relatório fornece a produção de energia de todos os microinversores para a data especificada."
    },
    "5": {
      "name": "Produção de Energia mensal por módulo.",
      "title": "Produção de Energia mensal por módulo.",
      "description": "Este relatório fornece a produção de energia de todos os microinversores para o mês especificado."
    },
    "20": {
      "name": "Relatório de autoteste do IQ-Relay",
      "title": "Relatório de resultados de autoteste do IQ-Relay",
      "description": "Este relatório fornece os resultados mais recentes do autoteste do IQ-Relay"
    },
    "25": {
      "name": "Relatório personalizado (em Wh)",
      "title": "Relatório personalizado",
      "description": ""
    }
  },
  "stats": {
    "total": "Energia całkowita",
    "peak_production": "Pico de potência",
    "latest_production": "Última potência",
    "peak_consumption": "Pico de consumo",
    "latest_consumption": "Último consumo",
    "recent_power": "Potência recente",
    "maintainer": "Entre em contato com o gestor",
    "enphase": "Entre em contato com o suporte da Enphase",
    "orenphase": "Ou entre em contato com o suporte da Enphase",
    "learn_more": "Saiba mais.",
    "where": "Onde é o problema?",
    "toGrid": "Aproximadamente %{value} exportado(s) para a rede",
    "fromGrid": "Aproximadamente %{value} importado(s) da rede",
    "normal": {
      "title": "Normal",
      "modal": "Seu sistema está operando normalmente."
    },
    "shortcomm": {
      "title": "Gateway não reportando",
      "hours": "Seu sistema não relatou dados para a nuvem Enphase nas últimas %{hours} horas.",
      "date": "Seu sistema não relatou dados para a nuvem Enphase desde %{date}.",
      "unknown": "Este sistema não está se reportando à nuvem Enphase.",
      "question": "A sua conexão com a internet caiu?",
      "help_topic_link": "Reconecte-se para ver o desempenho de seu sistema.",
      "link": "Clique aqui para ajuda."
    },
    "meter": {
      "title": "Medidor não reportando",
      "hours": "O medidor do seu sistema não reportou ao Gateway nas últimas %{númerodehoras} horas.",
      "date": "O medidor do seu sistema não reporta ao Gateway desde %{data}.",
      "ct_wiring": "Há um problema com as medições do medidor do Gateway. Entre em contato com seu mantenedor para obter ajuda.",
      "unknown": "O medidor do seu sistema não está reportando ao Gateway.",
      "link": "Clique aqui para ajuda.",
      "modal": "Seu medidor não relatou dados ao Gateway desde"
    },
    "meter_issue": {
      "title": "Problema do medidor",
      "ct_wiring": "Há um problema com as medições do medidor do Envoy.",
      "link": "Clique aqui para ajuda."
    },
    "battery": {
      "title": "Baterias CA não reportando",
      "modal": "Esta bateria CA não está enviando dados.",
      "message": "Algumas baterias CA não estão enviando dados.",
      "messageSome": "Algumas baterias CA, (%{count}), não estão enviando dados.",
      "link": "Clique aqui para ajuda."
    },
    "storage_idle": {
      "title": "Armazenamento Inativo",
      "modal": "Esta bateria CA não está carregando ou descarregando.",
      "date": "Pelo menos uma bateria CA não tem carregado ou descarregado desde %{date}.",
      "unknown": "Pelo menos uma bateria CA não está carregando ou descarregando.",
      "link": "Clique aqui para ajuda."
    },
    "encharge": {
      "title": "Bateria não reportando",
      "modal": "Esta bateria não está reportando dados.",
      "message": "A bateria não está a comunicar dados. Isto pode ocorrer se a comunicação sem fios entre o seu gateway e a bateria for fraca. Pode tratar-se de uma falha temporária que deverá ser resolvida em breve.",
      "requestMaintainer": "Se o problema persistir, contacte o seu responsável pela manutenção para obter ajuda.",
      "messageSome": "Algumas baterias (%{quantidade}) não estão reportando dados.",
      "link": "Clique aqui para ajuda."
    },
    "enpower": {
      "title": "Controlador do sistema não reportando",
      "modal": "Este controlador do sistema não está reportando dados.",
      "message": "O controlador do sistema não está a comunicar dados. Isto pode ocorrer se a comunicação sem fios entre o seu gateway e a controlador do sistema for fraca. Pode tratar-se de uma falha temporária que deverá ser resolvida em breve.",
      "requestMaintainer": "Se o problema persistir, contacte o seu responsável pela manutenção para obter ajuda.",
      "messageSome": "Alguns controladores de sistema (%{quantidade}) não estão reportando dados.",
      "link": "Clique aqui para ajuda."
    },
    "encharge_issue": {
      "title": "Erro de bateria",
      "modal": "Esta bateria tem um erro.",
      "message": "A bateria tem um erro."
    },
    "enpower_issue": {
      "title": "Erro do controlador do sistema",
      "modal": "Este controlador do sistema tem um erro.",
      "message": "O controlador do sistema tem um erro."
    },
    "micro": {
      "title": "Microinversores não reportando",
      "modal": "Este microinversor não está reportando dados ao Gateway.",
      "message": "Alguns microinversores não estão reportando dados ao Gateway.",
      "messageSome": "Alguns microinversores (%{quantidade}) não estão reportando dados ao Gateway.",
      "messageAll": "Nenhum microinversor está reportando dados ao Gateway.",
      "link": "Clique aqui para ajuda."
    },
    "power": {
      "title": "Problema de produção do sistema",
      "message": "Há um problema de produção em seu sistema.",
      "messageSome": "Este microinversor está informando um problema de produção.",
      "messageThreshold": "Seu sistema está produzindo menos energia do que o esperado.",
      "link": "Entre em contato com o suporte da Enphase para ajuda.",
      "maintainerlink": "Entre em contato com o responsável pela manutenção para ajuda."
    },
    "data_upload": {
      "title": "Transferência de dados em progresso"
    }
  }
};
module.exports = consumer;